import { connect } from 'react-redux';
import PrivateRoute from '../components/PrivateRoute'
import { authenticate } from '../actions';

const mapStateToProps = (state, ownProps) => {
  return {
    authenticate: state.authenticate,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateUser: (data) => {
      dispatch(authenticate(data));
    },
  };
};


const PrivateRouteContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);

export default PrivateRouteContainer;
